import { State } from '../../types/reducer/State';
import { sideBarPosition } from '../../services/sideBarPosition';

export function setSideBarPosition(state: State, position: any): State {
  sideBarPosition.set(position);
  return { ...state, sideBarPosition: position };
}
